


































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { Directory } from '@/@types/LibraryComponent';
import AddDirectoryModal from '@/components/documents/AddDirectoryModal.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { FindFileContentQueryDto, FindFilesDetail } from '@/@types/theoryGit/files';
import { vxm } from '@/store';

@Component({
  components: {
    AddDirectoryModal,
    AccountIcon,
  },
})
export default class DirectoryTable extends Vue {
  @Prop({ required: true, default: '' })
  private readMeData!: string;
  @Prop()
  private directories!: Array<Directory>;
  private isOpenSettingDirectoryModal: boolean = false;
  private isOpenAddDirectoryModal: boolean = false;
  private count: number = 8;

  private getFileNames() {
    return this.files.map((file) => {
      return file.filePath;
    });
  }

  private closeSettingDirectoryModal() {
    this.isOpenSettingDirectoryModal = false;
  }

  private listItems() {
    // dataのlistプロパティからcountプロパティ設定分に絞る
    const directories = this.directories;
    return directories.slice(0, this.count);
  }

  private changeIcon(path: string) {
    const extend = path.replace(/\.[^/.]+$/, '');
    switch (extend) {
      case 'txt':
        return 'mdi-file';
      default:
        return 'mdi-folder';
    }
  }

  private isMore() {
    this.count = this.directories.length;
  }

  private closeAddDirectoryModal() {
    this.isOpenAddDirectoryModal = false;
  }

  private sliceOid(oid: string) {
    return oid.slice(0, 10);
  }

  private get files() {
    return vxm.theoryGit.filesStore.getFiles?.results ?? [];
  }
}
